module.exports = __webpack_public_path__ + "img/claims-2.a63e245f.svg";